const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const { Base64 } = require('js-base64');

function apiFactory({
    baseUrl,
    requestHandler
  }) {
    const headers = {
      Accept: 'application/json'
    };
  
    function getUrl(endpoint) {
      return `${baseUrl}${endpoint}`;
    }
    
    return {

        getPortfolioSummary(inputParam, metaData) {
          const url = getUrl('get-user-portfolio-summary');
          const parsedMetaData = parseRequestMetaData(metaData);
          const reqOpts = {
            headers: merge(headers, parsedMetaData.headers),
            method: 'POST',
            json: true
          };
    
          const params = JSON.parse(Base64.decode(inputParam));;
    
          const body = {
            userId: parsedMetaData.qs.userId,
            destinationCurrency: params.destinationCurrency,
            pfRelID: params.pfRelID,
            branchCode: apiConfig.branchCode,
            language: parsedMetaData.portfolio.language

          }
    
          return requestHandler(merge(reqOpts, {
            url,
            body
          }));
        },
    
      };
    }
    
    
module.exports = apiFactory;
      